import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import NModal from '@/components/modal/index'
import NIcon from '@/components/icon/index'
import NHeader from '@/components/header/index'
import NButton from '@/components/button/index'
import NSearch from '@/components/search/index'
import favModal from '@/components/favModal/index'
import BaseModal from '@/components/baseModal/index'
import CheckBox from '@/components/checkBox/index'
import NFooter from '@/components/footer/index'
import NLogin from '@/components/login/index'
import NSelect from '@/components/select/index'
import NLoading from '@/components/loading/index'
import Alioss from '@/components/alioss/index'
import Toast from '@/components/toast/toast'
import Axios from './axios'
import VueLazyload from 'vue-lazyload'
import '@/components/toast/toast.scss'

import '@/assets/_variable.scss'
import '@/assets/base.scss'
import '@/assets/index.css'
import '@/assets/theme/index.css'
import './plugins/element.js'
import ElementUi from "element-ui"

import defaultCon from '@/components/defaultCon'
Vue.component('defaultCon', defaultCon)

Vue.config.productionTip = false
Vue.prototype.$axios = Axios //axios拦截器

Vue.use(NIcon)
Vue.use(Toast)
Vue.use(NButton)
Vue.use(NModal)
Vue.use(NHeader)
Vue.use(NFooter)
Vue.use(NSearch)
Vue.use(favModal)
Vue.use(BaseModal)
Vue.use(CheckBox)
Vue.use(NLogin)
Vue.use(NSelect)
Vue.use(NLoading)
Vue.use(ElementUi)
Vue.use(Alioss)

Vue.use(VueLazyload)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
